export const SERVERS = {
  Production: 'https://api.outlier.org',
  Development: 'http://localhost:1337',
  Staging: 'https://staging-dot-outlier-api.uc.r.appspot.com',
  AWS: 'https://api2.outlier.org'
}
